import PlantingProjectEditor from '../containers/PlantingProjectEditor/PlantingProjectEditor';

function Proposal() {
    return <PlantingProjectEditor proposalMode={true} />;
}

export default Proposal;
